import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const CardCollections = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_CARD_COLLECTION.FETCH_VEHICLE_WISE_CARD_COLLECTION:
      return { ...state, vehicleWiseCardCollection: action.value };
    case actions.FETCH_CARD_COLLECTION.FETCH_DAY_WISE_CARD_COLLECTION:
      return { ...state, dayWiseCardCollection: action.value };
    case actions.FETCH_CARD_COLLECTION.FETCH_CARD_COLLECTION_SUMMARY:
      return { ...state, cardCollectionSummary: action.value };
    case actions.FETCH_CARD_COLLECTION.FETCH_ISSUE_TICKET_CARD:
      return { ...state, issueTicketOnCard: action.value };
    case actions.FETCH_CARD_COLLECTION.FETCH_CARD_ISSUED:
      return { ...state, cardIssued: action.value };
    case actions.FETCH_CARD_COLLECTION.FETCH_CARD_RECHARGED:
      return { ...state, cardRecharged: action.value };
    default:
      return state;
  }
};

export default CardCollections;
